// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2tuo6","title":"Images90_title__2CjYe","images":"Images90_images__3rfJ1"};